import { Badge, Box } from "@mui/material";

 const MenuBadge = ({ count }) => {
  if (count > 0) {
    return (
      
      <Badge
        badgeContent={count}
        // max={99}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            right: 1,
            minWidth: 20,
            width: 20,
            height: 20,
            fontSize: 11,
            borderRadius: '50%',
            padding: 0,
          },
        }}
      />
    );
  }

  // ✅ Green dot when 0
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#22C55E', // green
        ml: 1,
      }}
    />
  );
};
 export default  MenuBadge;
